import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import BuildChildren from 'utils/BuildChildren';
import classNames from 'classnames';
import classes from './ExpandableListItemC.module.scss';

const ExpandableListItemC = (props) => {
  const {
    title,
    body,
    onClick,
    showBody,
    additionalPadding = true,
  } = props;

  if (!title || !body) {
    return null;
  }

  return (
    <div className={classNames(
      additionalPadding ? classes.container : classes.containerNoPadding, { [classes.toggleExpanded]: showBody },
    )}
    >
      <button aria-label='Toggle' className={classes.toggle} onClick={onClick} type='button'>
        <span className={classes.toggleContainer}>
          <h5
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div className={classes.iconWrapper}>
            <FontIcon
              className={classes.icon}
              icon={showBody ? 'far fa-minus-circle' : 'far fa-plus-circle'}
            />
          </div>
        </span>
      </button>
      {typeof body === 'string'
        ? <div className={classNames(classes.body, showBody ? '' : classes.hide)} dangerouslySetInnerHTML={{ __html: body }} />
        : <div className={showBody ? '' : classes.hide}> {BuildChildren(body)}</div>}
    </div>
  );
};

ExpandableListItemC.propTypes = {
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  additionalPadding: PropTypes.bool,
  onClick: PropTypes.func,
  showBody: PropTypes.bool,
};

export default ExpandableListItemC;
